/**
 * Transfer types that already live in transfer-v2, keyed by type id → base path (relative to the
 * language prefix). Everything else still opens the old page via `?type=`.
 */
const V2_TRANSFER_PATHS: Record<string, string> = {
  payment_foreign_transfer: 'transfer-page/payment_foreign_transfer',
};

/** Base path of a type that lives in transfer-v2, or undefined while it is still on v1. */
export const v2Path = (type?: string | null) => (type ? V2_TRANSFER_PATHS[type] : undefined);

/** Transfer form (payment, payment from a template, repeat of a past operation). */
export const transferFormUrl = (type?: string | null) =>
  v2Path(type) ?? `transfer-page?type=${type}`;

export const editTemplateUrl = (type?: string | null) => {
  const path = v2Path(type);

  return path ? `${path}/edit-template` : `templates-page/edit-template?type=${type}`;
};

export const newTemplateUrl = (type?: string | null) => {
  const path = v2Path(type);

  return path ? `${path}/new-template` : `templates-page/new-template?type=${type}`;
};
